import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { CampaignStatus } from 'src/app/models/campaign';
import { CampaignService } from 'src/app/services/campaign.service';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';

@Component({
    selector: 'app-campaign-stop-modal',
    templateUrl: './campaign-stop-modal.component.html',
    styleUrls: ['./campaign-stop-modal.component.scss']
})
export class CampaignStopModalComponent implements OnInit {
    public campaignId: string;
    public status: string;
    public step: number = 1;
    public startDate: Date;
    public endDate: Date;
    public minStartDate: Date;
    public today: Date = new Date();
    public upcomingStatusDate: Date | null = null;
    public isAdmin: boolean = false;
    dateFilter = (d: Date | null): boolean => {
        const date = d || new Date();
        return date >= new Date();
    };

    constructor(
        public dialog: MatDialog,
        private dialogRef: MatDialogRef<CampaignStopModalComponent>,
        private campaignService: CampaignService,
        private authenticationService: AuthenticationService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.campaignId = data.campaignId;
        this.status = data.status;
        this.startDate = data.startDate;
        this.endDate = data.endDate;
        this.minStartDate = moment(this.today).add(2, 'd').toDate();
        this.isAdmin = this.authenticationService.isAdmin();

        if (
            this.isAdmin &&
            (this.status === CampaignStatus.LIVE || this.status === CampaignStatus.PARTIALLY_LIVE)
        ) {
            this.step = 2;
            this.upcomingStatusDate = new Date();
        }
    }

    ngOnInit(): void {}

    onUpcomingStatusDateChanged(date: Date | null): void {
        if (date) this.upcomingStatusDate = date;
    }

    isUpcomingDateWithinRange(): boolean {
        if (!this.upcomingStatusDate || !this.startDate || !this.endDate) {
            return false;
        }

        const upcoming = moment(this.upcomingStatusDate);
        const start = moment(this.today).add(1, 'd').toDate();
        const end = moment(this.endDate);

        const result = upcoming.isAfter(start) && upcoming.isSameOrBefore(end);
        return result;
    }

    moveToStepTwo() {
        this.step = 2;
    }

    getTitle() {
        if (
            this.isAdmin &&
            (this.status === CampaignStatus.LIVE || this.status === CampaignStatus.PARTIALLY_LIVE)
        ) {
            return 'This campaign is live, are you sure you want to stop it?';
        }

        let title = 'Are you sure you want to stop this campaign?';
        return title;
    }

    getDescription() {
        if (
            this.isAdmin &&
            (this.status === CampaignStatus.LIVE || this.status === CampaignStatus.PARTIALLY_LIVE)
        ) {
            return '';
        }

        let description =
            'Your campaign is currently live. Are you sure you want to stop? Note: If you need to stop it urgently, please contact the media connector support.';

        if (this.status === CampaignStatus.PARTIALLY_LIVE) {
            description =
                'Your campaign is currently live. Are you sure you want to stop? Note: If you need to stop it urgently, please contact the media connector support.';
        }

        return description;
    }

    canStopCampaign(): boolean {
        if (
            this.isAdmin &&
            (this.status === CampaignStatus.LIVE || this.status === CampaignStatus.PARTIALLY_LIVE)
        ) {
            return true;
        }

        return this.isUpcomingDateWithinRange();
    }

    stopCampaign(): void {
        this.campaignService
            .updateCampaignStatus(this.campaignId, CampaignStatus.STOPPED, this.upcomingStatusDate)
            .subscribe(_ => {
                this.dialogRef.close(true);
            });
    }
}
